import { AddExternalContactRequestSchema, AddExternalContactResponseSchema } from './add-external-contact.schema';
/**
 * Add External Contact Endpoint Contract
 * Creates a new external contact in the organization
 */ export const addExternalContactContract = {
    method: 'POST',
    path: '/api/v2/external-contact',
    description: 'Create a new external contact in the organization',
    requestSchema: AddExternalContactRequestSchema,
    responseSchema: AddExternalContactResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-external-contact.contract.js.map